import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["citySelect", "regionSelect", "departmentSelect", "schoolSelect"]

  disconnect() {
    // Lifecycle cleanup (no timers or listeners to clear)
  }

  toggleTarget() {
    const selected = this.element.querySelector(
      'input[name="communication[target_type]"]:checked'
    )
    if (!selected) return

    const value = selected.value

    this.hideAll()

    switch (value) {
      case "city":
        this.show(this.citySelectTarget)
        break
      case "region":
        this.show(this.regionSelectTarget)
        break
      case "department":
        this.show(this.departmentSelectTarget)
        break
      case "specific":
        this.show(this.schoolSelectTarget)
        break
    }
  }

  hideAll() {
    if (this.hasCitySelectTarget) this.hide(this.citySelectTarget)
    if (this.hasRegionSelectTarget) this.hide(this.regionSelectTarget)
    if (this.hasDepartmentSelectTarget) this.hide(this.departmentSelectTarget)
    if (this.hasSchoolSelectTarget) this.hide(this.schoolSelectTarget)
  }

  show(element) {
    element.classList.remove("hidden")
  }

  hide(element) {
    element.classList.add("hidden")
  }
}
